import { render, staticRenderFns } from "./SenmonCareDivV2.vue?vue&type=template&id=2f0591c6&"
import script from "./SenmonCareDivV2.vue?vue&type=script&lang=ts&"
export * from "./SenmonCareDivV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports